export const prop =
  <A extends keyof B, B>(key: A) =>
  (obj: B) =>
    obj[key];
